import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "karyow_cookie_consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        const t = setTimeout(() => setVisible(true), 600);
        return () => clearTimeout(t);
      }
    } catch (e) {
      /* storage unavailable */
    }
  }, []);

  const decide = (choice) => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ choice, at: new Date().toISOString() })
      );
    } catch (e) {
      /* storage unavailable */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed z-[60] left-3 right-3 bottom-[76px] lg:left-auto lg:right-6 lg:bottom-6 lg:w-[420px] animate-slide-up-fade"
      style={{ animation: "cc-rise 420ms cubic-bezier(0.16,1,0.3,1)" }}
    >
      <style>{`@keyframes cc-rise{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}`}</style>
      <div className="relative rounded-2xl border border-[#2C353B] bg-[#0F1315]/95 backdrop-blur-xl p-5 shadow-[0_18px_50px_-12px_rgba(0,0,0,0.9)]">
        <button
          onClick={() => decide("dismissed")}
          data-testid="cookie-consent-close"
          aria-label="Dismiss"
          className="absolute top-3 right-3 p-1.5 rounded-lg text-zinc-500 hover:text-white hover:bg-[#1B2226] transition-colors"
        >
          <X className="h-4 w-4" />
        </button>

        <div className="flex items-start gap-3 pr-6">
          <div className="h-9 w-9 shrink-0 rounded-xl bg-lime-400/10 border border-lime-400/30 flex items-center justify-center">
            <Cookie className="h-4.5 w-4.5 text-lime-400" style={{ height: 18, width: 18 }} />
          </div>
          <div className="min-w-0">
            <div className="font-display text-sm font-semibold text-white">
              We use cookies
            </div>
            <p className="mt-1.5 text-xs leading-relaxed text-zinc-400">
              Essential cookies keep you signed in. Optional ones help us measure
              performance and improve ad tooling. Read our{" "}
              <Link
                to="/cookies"
                data-testid="cookie-consent-policy-link"
                className="text-lime-400 underline decoration-lime-400/40 underline-offset-2 hover:decoration-lime-400"
              >
                Cookie Policy
              </Link>
              .
            </p>
          </div>
        </div>

        <div className="mt-4 flex flex-col sm:flex-row gap-2">
          <button
            onClick={() => decide("accepted")}
            data-testid="cookie-accept-btn"
            className="flex-1 rounded-xl bg-lime-400 px-4 py-2.5 text-sm font-semibold text-[#0A0D0E] hover:bg-lime-300 active:scale-[0.98] transition-all"
          >
            Accept all
          </button>
          <button
            onClick={() => decide("essential")}
            data-testid="cookie-essential-btn"
            className="flex-1 rounded-xl border border-[#2C353B] px-4 py-2.5 text-sm font-medium text-zinc-300 hover:text-white hover:border-zinc-500 active:scale-[0.98] transition-all"
          >
            Essential only
          </button>
        </div>
      </div>
    </div>
  );
}
